import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth as useAuthContext } from '../context/AuthContext';
import api from '../services/api';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';

const SubscriptionCancel: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, login } = useAuthContext();
  
  // Fonction pour vérifier si l'utilisateur est authentifié via localStorage
  const checkLocalAuthentication = (): boolean => {
    const token = localStorage.getItem('token');
    return !!token;
  };
  
  useEffect(() => {
    // Vérifier si l'utilisateur est authentifié via localStorage
    const locallyAuthenticated = checkLocalAuthentication();
    
    if (!locallyAuthenticated && !isAuthenticated) {
      // Si l'utilisateur n'est pas authentifié ni localement ni via le contexte
      console.log('Utilisateur non authentifié, redirection vers login');
      const returnUrl = location.pathname;
      navigate(`/login?returnUrl=${encodeURIComponent(returnUrl)}`);
    } else if (locallyAuthenticated && !isAuthenticated) {
      // Si l'utilisateur est authentifié localement mais pas dans le contexte
      // Restaurer la session à partir du localStorage
      console.log('Session trouvée dans localStorage, restauration du contexte');
      const storedToken = localStorage.getItem('token');
      const storedUser = localStorage.getItem('user');
      
      if (storedToken && storedUser) {
        // Configurer le token pour les requêtes API
        api.defaults.headers.common['Authorization'] = `Bearer ${storedToken}`;
        
        // Restaurer le contexte d'authentification
        login({
          token: storedToken,
          user: JSON.parse(storedUser)
        });
      }
    }
  }, [isAuthenticated, location.pathname, navigate, login]);

  const handleGoToSubscription = () => {
    navigate('/subscription');
  };

  return (
    <div className="container mx-auto px-4 py-16">
      <Card className="max-w-lg mx-auto">
        <div className="flex flex-col items-center justify-center py-8">
          <div className="bg-yellow-100 p-3 rounded-full mb-4">
            <svg className="h-8 w-8 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h2 className="text-xl font-semibold">Paiement annulé</h2>
          <p className="text-gray-600 mt-2 text-center">
            Vous avez annulé le processus de paiement. Votre abonnement n'a pas été modifié.
          </p>
          <Button onClick={handleGoToSubscription} className="mt-6">
            Retour aux abonnements
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default SubscriptionCancel;
